export default __webpack_public_path__ + "static/media/fromthedarkness.442aa89d.png";